var styles = ["[_nghost-%COMP%]{width:100%;display:-webkit-box;display:-webkit-flex;display:flex;margin:0;min-height:100%;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row wrap;flex-flow:row wrap}"];
export { styles as styles };
